<template>
    <div>
      <div class="flex-box">
        <Form ref="form" :rules="formRules" :model="formData" style="margin-top:24px" :label-width="100" >
          <Row>
            <Col span="6">
              <FormItem label="资产一级分类" prop="oneCategoryName">
                <Select v-model="formData.oneCategoryName" placeholder="请选择" style="width: 200px" @on-change="getTwo">
                  <Option value=''>请选择</Option>
                  <Option v-for="(item,index) in oneCategoryListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="6">
              <FormItem label="资产二级分类" prop="twoCategoryName">
                <Select v-model="formData.twoCategoryName" placeholder="请选择" style="width: 200px">
                  <Option value=''>请选择</Option>
                  <Option v-for="(item,index) in twoCategoryListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="6">
              <FormItem label="资产名称" prop="assetsName">
                <input id="suggestIdbase1" style="width:200px" v-model="formData.assetsName" class="input-long ivu-input" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="6">
              <FormItem label="资产编码" prop="assetsCode">
                <input id="suggestIdbase4" style="width:200px" v-model="formData.assetsCode" class="input-long ivu-input" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="6">
              <FormItem label="资产状态" prop="assetsStatus" :label-width="100">
                <Select v-model="formData.assetsStatus" style="width:200px">
                  <Option value=''>请选择</Option>
                  <Option v-for="(item,index) in assetsStatusListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
<!--          <Row>-->
<!--            <Col span="6">-->
<!--              <FormItem label="资产总数" prop="stockNumber">-->
<!--                <input id="suggestIdbase3" style="width:200px" v-model="formData.stockNumber" class="input-long ivu-input" />-->
<!--              </FormItem>-->
<!--            </Col>-->
<!--          </Row>-->
<!--          <Row>-->
<!--            <Col span="6">-->
<!--              <FormItem label="入库时间" prop="stockStorageTime">-->
<!--                <Date-picker style="width:200px" type="date" v-model="formData.stockStorageTime" placeholder="选择日期" format="yyyy-MM-dd" ></Date-picker>-->
<!--              </FormItem>-->
<!--            </Col>-->
<!--          </Row>-->
        </Form>
        <Form
            :ref="'search'+index"
            :model="itemP"
            :rules="ruleValidate2"
            :label-width="100"
            v-for="(itemP,index) in sizeDtos"
            :key="'index2'+index"
        >
          <Row class="max64">
            <Col span="4">
              <FormItem prop="sizeCode" label="规格型号">
                <input style="width:120px" v-model="itemP.sizeCode" class="input-long ivu-input" />
              </FormItem>
            </Col>
            <Col span="3">
              <FormItem prop="sizeNum" label="总数量">
                <input style="width:80px" v-model="itemP.sizeNum" class="input-long ivu-input" />
              </FormItem>
            </Col>
            <Col span="4">
              <FormItem prop="unit" label="单位">
                <Select v-model="itemP.unit" style="width:80px">
                  <Option value=''>请选择</Option>
                  <Option v-for="(item,index) in unitListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="3" v-if="itemP.fid" style="line-height: 32px;">
              <span>已发放数量：{{itemP.sizeProvidedNumber}}</span>
            </Col>
<!--            <Col span="3" v-if="itemP.fid" style="line-height: 32px;">-->
<!--              <span>发放日期：{{format(itemP.createdTime, false)}}</span>-->
<!--            </Col>-->
            <Col span="1"  v-if="!index">
              <a style="line-height:32px;margin-left:5px" @click.stop="addItem"> + 添加</a>
            </Col>
            <Col span="1" v-if="index">
              <a style="line-height:32px;margin-left:5px" @click.stop="deleteItem(itemP,index)"> 删除</a>
            </Col>
            <Col span="1" v-if="itemP.fid">
              <a style="line-height:32px;margin-left:3px" @click.stop="provide(itemP.fid,index)"> 发放</a>
            </Col>
          </Row>
        </Form>
      </div>

              <provide-assets-index
                  :n="addN"
                  :sizeFid="sizeFid"
                  :assetsFid="assetsFid"
                  @done="getDetail">
              </provide-assets-index>

      <div class="a1">
        <Button type="primary" @click.stop="save" class="mb16" :loading="preLoading">保存</Button>
      </div>
    </div>
</template>

<script>
import {getAssetsInfoByFid} from "api/assets";
import {updateAssetsInfo} from "api/assets";
import {getCategoryTypeList} from "api/assets";
import {formatDateTime} from "utils/format";
import ProvideAssetsIndex from "@/views/gdMap/provideAssets";

export default {
  components: {
    ProvideAssetsIndex
  },
  props: {
    pid:{
      default:null
    },
  },
  data() {
    return {
      preLoading:false,
      sizeDtos :[],
      addN:0,
      sizeFid:'',
      assetsFid:this.$route.query.id,
      assetsStatusListData: [
        {
          value: 0,
          text: '已入库',
        },
        {
          value: 1,
          text: '已发放',
        },
        {
          value: 2,
          text: '部分发放',
        }
      ],
      unitListData:[
        {
          value: 1,
          text: '箱',
        },
        {
          value: 2,
          text: '包',
        },
        {
          value: 3,
          text: '个',
        },
        {
          value: 4,
          text: '根',
        }
      ],
      oneCategoryListData: [],
      twoCategoryListData:[],
      map: null,
      type: 'polygon',
      formData: {
        oneCategoryName:'',
        twoCategoryName:'',
        assetsName:'',
        assetsCode:'',
        assetsStatus:'',
        // stockNumber:'',
        // stockStorageTime:'',

      },
      formRules:{
        assetsName:[{ required: true, message: '*' ,trigger: 'change', type:'string'}],
        assetsCode:[{ required: true, message: '*' ,trigger: 'change', type:'string'}],
        // stockStorageTime:[{ required: true, message: '*' ,trigger: 'change', type:'date', validator: this.validateDate}],
        oneCategoryName:[{ required: true, message: '*' ,trigger: 'change', type:'string'}],
        twoCategoryName:[{ required: true, message: '*' ,trigger: 'change', type:'string'}],
        assetsStatus:[{ required: true, message: '*' ,trigger: 'change', type:'number'}],
        // stockNumber:[{ required: true, message: '请输入数字' ,trigger: 'change', validator: this.validateNumber}]
      },
      ruleValidate2:{
        sizeCode:[
          { required: true, message: '*', trigger: 'change',type:'string'}
        ],
        sizeNum:[
          { required: true, message: '请输入数字', trigger: 'change',type:'number'}
        ],
      }
    };
  },
  created(){
    getCategoryTypeList(
        {
          parentCategoryCode:-1
        }
    ).then(res => {
      if (!res.data) {
        return
      }
      this.oneCategoryListData = res.data.categoryList
      this.unitListData = res.data.unitCondition
    }).catch(() => {
      return
    })

    this.getDetail()
  },
  mounted() {

  },
  methods: {
    getData(){},
    addItem(){
      this.sizeDtos.push(
          {
            fid:'',
            sizeCode:'',
            sizeNum:'',
            sizeSurplusNumber:'',
            sizeProvidedNumber:'',
            unit:'',
            createdTime:''
          }
      )
    },
    deleteItem(item,index){
      this.$Modal.confirm({
        content: '<p>确认删除？</p>',
        onOk:() => {
          this.sizeDtos.splice(index,1)
        }
      })
    },
    provide(item,index){
      this.sizeFid = item
      this.addN++
    },
    validateNumber(rule, value, callback) {
      const pattern = /^\d+$/
      if (!pattern.test(value)) {
        callback(new Error('请输入正确数字'));
      }
      callback();
    },
    getTwo(value){
      if (!value){
        return
      }
      getCategoryTypeList(
          {
            parentCategoryCode:value
          }
      ).then(res => {
        if (!res.data) {
          return
        }
        this.twoCategoryListData = res.data.categoryList
      }).catch(() => {
        return
      })
    },
    clear() {

    },
    close() {
    },
    getDetail(){
      getAssetsInfoByFid({assetsFid:this.assetsFid}).then( res=> {
        this.formData.oneCategoryName = res.data.oneCategoryName
        this.formData.twoCategoryName = res.data.twoCategoryName
        this.formData.assetsName = res.data.assetsName
        this.formData.assetsCode = res.data.assetsCode
        this.formData.assetsStatus = res.data.assetsStatus
        // this.formData.stockNumber = res.data.stockNumber
        // this.formData.stockStorageTime = this.format(res.data.stockStorageTime)
        this.sizeDtos = res.data.sizeDtos
      })
    },
    format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    },
    // cancel(){
    //  return
    // },
    save() {
      this.$refs['form'].validate( bool => {
        if(bool){
          if(this.assetsFid&&this.assetsFid!=''){
            const param = {
              fid:this.assetsFid,
              sizeDtos:this.sizeDtos,
              ...this.formData
            }
            this.preLoading=true
            updateAssetsInfo(param).then( res=> {
              this.$Message.success('更新成功');
              this.closeTag()
              this.preLoading=false
            }).catch( () => {
              this.preLoading=false
            })
          }
        }else{
          return
        }
      })

    },
    closeTag(){
      this.$routerGo({ name: 'putAssetsManage'})
    },
  },
};
</script>

<style lang="less" scoped>
.modalnobefore {
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 500px;
}
.flex-box {
  //display: flex;
  //margin-bottom: 24px;
  //& > div {
  //  flex: auto;
  //  display: flex;
  //  margin-right: 20px;
  //  span {
  //    display: flex;
  //    width: auto;
  //    line-height: 30px;
  //  }
  //
  //}
}
.content-box {
  flex: 1;
  display: flex;
  position: relative;
  .content-l {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
  }
  #grouplist {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .content-r {
    flex: auto;
    .r-title {
      background: #649dd6;
      color: #fff;
      padding-left: 20px;
      height: 30px;
      line-height: 30px;
      .refresh {
        color: #fff;
        cursor: pointer;
        float: right;
        margin-right: 20px;
      }
    }
    .content {
      padding: 20px;
      li {
        border-bottom: 1px solid #ccc;
        margin-bottom: 10px;
        &:last-child {
          border-bottom: none;
        }
        p {
          height: 30px;
          line-height: 30px;
          .r-name {
            font-weight: bold;
            color: green;
            cursor: pointer;
            display: inline-block;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
.model-new{
  height:600px;
}
#container {
  /deep/ .amap-info-content {
    padding: 0;
    background: #fff;
    min-width: 250px;
  }
  /deep/ .amap-info-close {
    right: 0 !important;
    top: 3px;
  }
  /deep/ .info-content {
    padding: 10px;
    p {
      line-height: 25px;
      height: 25px;
      padding: 5px;
      color: #333;
      word-break: break-all;
      width: 200px;
    }
    margin-bottom: 10px;
  }
}
.a1 {
  text-align: center;
  margin-top: 30px;
}
</style>
